// Funnel events for the survey.
//
// The point of measuring this is not traffic, it is the DROP-OFF. A count of visits cannot
// tell "nobody clicked start" from "everybody quit at question four", and those two want
// completely different fixes. So every step fires, not just the ends.
//
// Fails silently and never throws: an analytics error must not be able to break a survey.
export function track(event: string, params: Record<string, any> = {}) {
  try {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event, ...params });
  } catch {
    /* no-op */
  }
}
